import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Button } from "components/Button";
import { EmptyStatePlaceholder } from "components/Page/SubmittedApplicationV2/EmptyStatePlaceholder";

export const DataGridNoResults: React.FC<{ className?: string; isFilterEmpty: boolean; onFilterClear: () => void }> = ({
    className,
    isFilterEmpty,
    onFilterClear,
}) => {
    return (
        <div className={classNames("d-flex flex-column align-items-center justify-content-center text-center", className)}>
            <EmptyStatePlaceholder
                className="pb-3"
                placeholderImage={
                    <FontAwesomeIcon className="p-4 border border-2 rounded-circle" icon={["fal", "magnifying-glass"]} size="2xl" />
                }
                title="No results found"
                description="Try adjusting your search to find matches."
            />
            {!isFilterEmpty && (
                <Button variant="link" className="text-decoration-none" onClick={() => onFilterClear()}>
                    Clear all
                </Button>
            )}
        </div>
    );
};
